<section class="video-hero-section">
    <div class="video-container">
      <video #backgroundVideo class="background-video" [poster]="posterImage" autoplay muted loop playsinline>
        <source [src]="videoUrl" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
  
    <div class="content-container">
      <div class="decorative-circles">
        <div class="circle circle-1">
          <svg viewBox="20 20 160 160" height="200" width="200" xmlns="http://www.w3.org/2000/svg">
            <path d="M180 100c0 44.183-35.817 80-80 80s-80-35.817-80-80 35.817-80 80-80 80 35.817 80 80z"></path>
          </svg>
        </div>
        <div class="circle circle-2">
          <svg viewBox="20 20 160 160" height="200" width="200" xmlns="http://www.w3.org/2000/svg">
            <path d="M180 100c0 44.183-35.817 80-80 80s-80-35.817-80-80 35.817-80 80-80 80 35.817 80 80z"></path>
          </svg>
        </div>
        <div class="circle circle-3">
          <svg viewBox="20 20 160 160" height="200" width="200" xmlns="http://www.w3.org/2000/svg">
            <path d="M180 100c0 44.183-35.817 80-80 80s-80-35.817-80-80 35.817-80 80-80 80 35.817 80 80z"></path>
          </svg>
        </div>
      </div>
  
      <div class="main-heading">
        <h1>
          <span class="white-text">Amplify Your Earnings,</span>
          <span class="red-text"> Accelerate Your Growth</span>
          <span class="white-text"> with Calsoft</span>
        </h1>
      </div>
  
      <div class="about-section">
        <div class="about-content">
          <h3 class="about-title">About Us</h3>
          <p class="about-description">
            At Calsofts Affiliate Marketing, we empower forward-thinking affiliates with cutting-edge tools, 
            real-time analytics, and competitive commissions. We're not just an affiliate program—we're a 
            dynamic partnership committed to unlocking your growth and accelerating your success in the 
            digital marketing world.
          </p>
          <button class="learn-more-button" (click)="learnMore()">
            <span>Learn More</span>
            <span class="button-icon">
              <svg viewBox="0 0 200 200" height="200" width="200" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 29.5c-38.874 0-70.5 31.626-70.5 70.5s31.626 70.5 70.5 70.5 70.5-31.626 70.5-70.5-31.626-70.5-70.5-70.5zm0 133c-34.463 0-62.5-28.037-62.5-62.5S65.537 37.5 100 37.5s62.5 28.037 62.5 62.5-28.037 62.5-62.5 62.5zm29.428-65.328a4 4 0 0 1 0 5.656l-26.597 26.597a3.982 3.982 0 0 1-.612.501c-.099.066-.206.111-.308.167-.126.069-.246.145-.38.2-.133.055-.271.086-.408.126-.113.034-.222.077-.339.101a3.977 3.977 0 0 1-1.566 0c-.117-.023-.225-.067-.339-.1-.137-.04-.275-.072-.408-.127-.133-.055-.253-.131-.379-.199-.103-.057-.211-.102-.309-.168a3.982 3.982 0 0 1-.612-.501l-26.597-26.597a4 4 0 1 1 5.656-5.656L96 116.942V73.4a4 4 0 0 1 8 0v43.542l19.771-19.771a4 4 0 0 1 5.657.001z"></path>
              </svg>
            </span>
          </button>
        </div>
      </div>
    </div>
  </section>